import { findWhere } from '@/helpers/ArrayUtils'

export const getIntroCopy = (state, getters) => {
	return findWhere(state.copy.intro, {id: state.targetIndex}); 
}